// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-title {
    text-align: left;
    color: #333;
    margin: 0;
    padding: 0;
    font-size: 2em;
    margin-top: 20px;
    margin-bottom: 15px;
}

/* Container */
.user-settings-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  max-width: 800px;
}

/* Error Message */
.adm-error-message {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background-color: #fef2f2;
  border: 1px solid #fecaca;
  border-left: 4px solid #ef4444;
  border-radius: 8px;
  color: #991b1b;
  font-size: 14px;
  font-weight: 500;
  animation: adm-shake 0.4s ease-in-out;
}

.adm-error-message svg {
  flex-shrink: 0;
  color: #ef4444;
}

@keyframes adm-shake {
  0%, 100% { transform: translateX(0); }
  20%, 60% { transform: translateX(-4px); }
  40%, 80% { transform: translateX(4px); }
}

/* Control Group */
.adm-control-group {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.user-settings-input {
  background-color: white;
  border-radius: 8px;
}

.user-settings-input label {
  font-size: 14px;
  font-weight: 500;
  color: #444;
}

.adm-actions-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.adm-actions-right {
  display: flex;
  gap: 10px;
  align-items: center;
}

.adm-pwd-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 8px;
  outline: none;
  padding: 8px 16px;
  height: 38px;
  box-sizing: border-box;
  background-color: transparent;
  border: 1px solid #5616ea;
  color: #5616ea;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease;
  font-size: 14px;
}

.adm-pwd-btn:hover {
  background-color: #f3eaff;
  transform: translateY(-1px);
}

.adm-pwd-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
  transform: none;
}

.adm-discard-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  outline: none;
  padding: 8px 16px;
  height: 38px;
  box-sizing: border-box;
  background-color: #ededed;
  border: 1px solid rgb(219, 219, 219);
  color: black;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease;
  font-size: 14px;
}

.adm-discard-btn:hover {
  background-color: #e0e0e0;
  transform: translateY(-1px);
}

.adm-discard-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
  transform: none;
}

.adm-save-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  outline: none;
  padding: 8px 16px;
  height: 38px;
  box-sizing: border-box;
  background-color: #5616ea;
  border: none;
  color: white;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease;
  font-size: 14px;
}

.adm-save-btn:hover {
  background-color: #4a14d6;
  transform: translateY(-1px);
}

.adm-save-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
  transform: none;
}

.remove-account-btn {
  font-size: 14px;
  font-weight: 500;
  color: red !important;
  background-color: transparent !important;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  text-align: center;
  transition: background-color 0.3s ease, transform 0.3s ease;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);
  border: 1px solid red !important;
  align-self: flex-start;
}

.remove-account-btn:hover {
  background-color: #4a14d6;
  transform: translateY(-1px);
}`, "",{"version":3,"sources":["webpack://./src/components/Administration.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,WAAW;IACX,SAAS;IACT,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,WAAW,2BAA2B,EAAE;EACxC,WAAW,0BAA0B,EAAE;AACzC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,2DAA2D;EAC3D,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,2DAA2D;EAC3D,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,2DAA2D;EAC3D,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,2DAA2D;EAC3D,yCAAyC;EACzC,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B","sourcesContent":[".settings-title {\r\n    text-align: left;\r\n    color: #333;\r\n    margin: 0;\r\n    padding: 0;\r\n    font-size: 2em;\r\n    margin-top: 20px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n/* Container */\r\n.user-settings-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n  padding: 20px;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 10px;\r\n  box-sizing: border-box;\r\n  background: rgba(255, 255, 255, 0.75);\r\n  backdrop-filter: blur(10px);\r\n  -webkit-backdrop-filter: blur(10px);\r\n  max-width: 800px;\r\n}\r\n\r\n/* Error Message */\r\n.adm-error-message {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 14px 16px;\r\n  background-color: #fef2f2;\r\n  border: 1px solid #fecaca;\r\n  border-left: 4px solid #ef4444;\r\n  border-radius: 8px;\r\n  color: #991b1b;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  animation: adm-shake 0.4s ease-in-out;\r\n}\r\n\r\n.adm-error-message svg {\r\n  flex-shrink: 0;\r\n  color: #ef4444;\r\n}\r\n\r\n@keyframes adm-shake {\r\n  0%, 100% { transform: translateX(0); }\r\n  20%, 60% { transform: translateX(-4px); }\r\n  40%, 80% { transform: translateX(4px); }\r\n}\r\n\r\n/* Control Group */\r\n.adm-control-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n}\r\n\r\n.user-settings-input {\r\n  background-color: white;\r\n  border-radius: 8px;\r\n}\r\n\r\n.user-settings-input label {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: #444;\r\n}\r\n\r\n.adm-actions-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.adm-actions-right {\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: center;\r\n}\r\n\r\n.adm-pwd-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  border-radius: 8px;\r\n  outline: none;\r\n  padding: 8px 16px;\r\n  height: 38px;\r\n  box-sizing: border-box;\r\n  background-color: transparent;\r\n  border: 1px solid #5616ea;\r\n  color: #5616ea;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease, transform 0.3s ease;\r\n  font-size: 14px;\r\n}\r\n\r\n.adm-pwd-btn:hover {\r\n  background-color: #f3eaff;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.adm-pwd-btn:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n  transform: none;\r\n}\r\n\r\n.adm-discard-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 8px;\r\n  outline: none;\r\n  padding: 8px 16px;\r\n  height: 38px;\r\n  box-sizing: border-box;\r\n  background-color: #ededed;\r\n  border: 1px solid rgb(219, 219, 219);\r\n  color: black;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease, transform 0.3s ease;\r\n  font-size: 14px;\r\n}\r\n\r\n.adm-discard-btn:hover {\r\n  background-color: #e0e0e0;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.adm-discard-btn:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n  transform: none;\r\n}\r\n\r\n.adm-save-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 8px;\r\n  outline: none;\r\n  padding: 8px 16px;\r\n  height: 38px;\r\n  box-sizing: border-box;\r\n  background-color: #5616ea;\r\n  border: none;\r\n  color: white;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease, transform 0.3s ease;\r\n  font-size: 14px;\r\n}\r\n\r\n.adm-save-btn:hover {\r\n  background-color: #4a14d6;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.adm-save-btn:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n  transform: none;\r\n}\r\n\r\n.remove-account-btn {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: red !important;\r\n  background-color: transparent !important;\r\n  padding: 10px 20px;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  text-align: center;\r\n  transition: background-color 0.3s ease, transform 0.3s ease;\r\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);\r\n  border: 1px solid red !important;\r\n  align-self: flex-start;\r\n}\r\n\r\n.remove-account-btn:hover {\r\n  background-color: #4a14d6;\r\n  transform: translateY(-1px);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
